import { authApi } from "../../api/auth";
import { ApiError } from "../../api/http";
import type { User } from "../../api/types";

export const meQuery = {
  queryKey: ["me"] as const,
  queryFn: async (): Promise<User | null> => {
    try {
      return await authApi.me();
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) return null;
      throw err;
    }
  },
  staleTime: 5 * 60_000,
};
